import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Collapse } from '@mui/material';
import deepmerge from 'deepmerge';
import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'ExpandDisclaimer' })(theme => deepmerge({
	root: {

	},
	button: {
		display: 'inline-flex',
		alignItems: 'center',
		cursor: 'pointer'
	},
	label: {
		fontWeight: 'bold',
		textTransform: 'uppercase',
		fontSize: '14px',
		lineHeight: '20px'
	},
	indicator: {
		marginLeft: 10,
		transitionDuration: '0.25s',
		transitionProperty: 'transform',
		color: theme.palette.dropdownIcon,
		'&.less': {
			transform: 'rotate(0deg)'
		},
		'&.more': {
			transform: 'rotate(180deg)'
		}
	},
	content: {
		textAlign: 'justify',
		padding: '26px 0 0 0',
		margin: 0,
		fontSize: '12px',
		lineHeight: '16px',
		[theme.breakpoints.up('sm')]: {
			fontSize: '14px',
			lineHeight: '20px'
		},
		[theme.breakpoints.up('md')]: {
			fontSize: '12px',
			lineHeight: '16px'
		},
		[theme.breakpoints.up('lg')]: {
			fontSize: '14px',
			lineHeight: '20px'
		}
	}
}, theme?.Skoda?.overrides?.SkodaExpandDisclaimer ?? {}));

export type DisclaimerExpandProps = {
	title: string;
	openDefault?: boolean;
	classes?: Partial<ReturnType<typeof useStyles>['classes']>;
	children: string;
};

const DisclaimerExpand: React.FC<DisclaimerExpandProps> = (props) => {
	const { title, openDefault, children } = props;
	const [expanded, setExpanded] = useState(openDefault);

	let { classes, cx } = useStyles(undefined, { props });

	return (
		<div data-test='disclaimer' className={classes.root}>
			<div data-test='disclaimer-button' className={classes.button}
				onClick={() => setExpanded(prev => !prev)}>
				<span className={classes.label}>
					{title}
				</span>
				<ExpandLessIcon
					className={cx(classes.indicator, expanded ? 'less' : 'more')} />
			</div>
			<Collapse in={expanded}>
				<p data-test='disclaimer-content' className={classes.content} dangerouslySetInnerHTML={{ __html: children }} />
			</Collapse>
		</div>
	);
};

export default DisclaimerExpand;
